import {trim, arrayUnique} from '../assets/functions'

export default {
  data() {
    return {
      editIndex: -2,  //编辑位置控制，-2无编辑位置，-1新增编辑 ，>=0编辑位置的索引
      copyValues: [],
      valueMapping: false, //值映射
    }
  },
  props: {
    values: {
      type: Array,
      default() {
        return []
      }
    },
    value: {
      type: [String, Number],
      default: ''
    },
    size: {
      type: String,
      default: '14px'
    },
    editable: Boolean,
  },

  created() {
    this.update()
  },
  methods: {
    update() {

      if (this.values.every((val) => val && val.value && val.content)) {
        this.valueMapping = true;
        let d = []
        this.values.forEach((val) => {
          if (val.value) {
            d.push({value: val.value, content: val.content})
          }
        })
        this.copyValues = d;
      } else if (this.values.every((val) => val instanceof Array)) {
        var d = []
        this.values.forEach((v2) => {
          v2.forEach((v3) => {
            let v4 = trim(v3);
            if (v4 && d.every((v) => v.value !== v4)) {
              d.push({
                content: v4,
                value: v4,
              })
            }
          })
        })
        this.copyValues = d;
      } else {
        var d = []
        this.values.forEach((val) => {
          if (val) {
            d.push({
              content: val,
              value: val,
            })
          }
        });
        this.copyValues = d
      }
    },
    //添加时，失去焦点的操作
    addblur(e) {
      var v = trim(e.target.innerText)

      if (v && this.editIndex >= -1 && !this.copyValues.some(val => val.value === v)) {
        this.copyValues.push({content: v, value: v})
        this.blur(this.copyValues.length - 1, e)
      } else {
        this.editIndex = -2;
      }
    },

  }
}
